import { useAuth } from '../contexts/AuthContext';
import ArtistDashboard from './dashboard/ArtistDashboard';
import PromoterDashboard from './dashboard/PromoterDashboard';
import BookerDashboard from './dashboard/BookerDashboard';

export default function Dashboard() {
  const { user } = useAuth();

  if (user?.role === 'artist') return <ArtistDashboard />;
  if (user?.role === 'promoter') return <PromoterDashboard />;
  if (user?.role === 'booker') return <BookerDashboard />;

  return (
    <div className="max-w-4xl mx-auto px-4 py-12 text-center animate-fadeIn">
      <h1 className="th-page-title mb-4">Dashboard</h1>
      <p className="th-text-secondary">Rôle non reconnu. Contactez le support.</p>
    </div>
  );
}
